import React from "react";

import { useEntityDetailContext } from "contexts/EntityDetailContext";

import AppTable from "components/Shared/AppTable/AppTable";

import { localizeDateMed } from "utils/dateFormats";

const EntityPlan = () => {
  const { entityDetail } = useEntityDetailContext();

  const columns = [
    { name: "Name", selector: (row) => row?.plan },
    { name: "Licenses", selector: (row) => row?.quantity },
    { name: "Frequency", selector: (row) => row?.frequency },
    {
      name: "Start Date",
      selector: (row) => row?.startDate,
      cell: (row) => localizeDateMed(row?.startDate),
    },
    {
      name: "End Date",
      selector: (row) => row?.endDate,
      cell: (row) => localizeDateMed(row?.endDate),
    },
    {
      name: "Status",
      cell: (row) => (row?.isActive ? "Active" : "Inactive"),
    },
  ];

  return <AppTable columns={columns} data={entityDetail?.entityPlans} />;
};

export default EntityPlan;
